import { Loader } from "@/components/common/loader";
import { CatalogListItemSmall } from "@/features/diets/components/diet-list-item-small";
import { DietsNoFound } from "@/features/diets/components/diets-no-found";
import { mapDietSearchResultsToDietCatalog } from "@/features/diets/helpers/mappers";
import type { Globals } from "@/features/globals/types/globals.type";
import { useDietsResults } from "@/features/multidiet/api/hooks/use-get-diets-results";
import type { CateringCatalog } from "../types/catering-catalog.type";

type CateringDietListProps = {
  catering: CateringCatalog;
  globals?: Globals | null;
};

export const CateringDietList = ({
  catering,
  globals,
}: CateringDietListProps) => {
  const { data, isLoading } = useDietsResults({
    filters: { cateringId: catering.id, pagination: false },
  });

  if (isLoading) return <Loader />;

  if (data && data["hydra:totalItems"] === 0) return <DietsNoFound />;

  const mappedData = mapDietSearchResultsToDietCatalog(data!);

  return (
    <div className="flex w-full flex-col gap-6 pt-6 pb-4 md:flex-row md:gap-4 md:space-x-4">
      {mappedData?.["hydra:member"].map((diet, index) => (
        <CatalogListItemSmall
          diet={diet}
          elements={{ heart: false, dietType: false }}
          globals={globals}
          index={index}
          key={diet.id}
        />
      ))}
    </div>
  );
};
